import React from "react";
import {
  Box,
  Typography,
  Container,
  Avatar,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import logoKevinCalizaya from "../img/kevcalizaya.jpg"; // Ruta del avatar

const AcercaDe = () => {
  const secciones = [
    {
      titulo: "Vida Universitaria",
      items: [
        {
          titulo: "Cálculo Ponderado",
          descripcion:
            "Calcula tu nota final fácilmente ingresando tus calificaciones parciales y porcentajes. Ideal para visualizar tu rendimiento académico.",
        },
        {
          titulo: "Sistema SIA",
          descripcion:
            "Guías paso a paso para acceder, ver tu matrícula, historial académico, y más en el Sistema Integrado Académico.",
        },
        {
          titulo: "Conexión Wifi",
          descripcion:
            "Accede a la red gratuita instalada en aulas. Aprende cómo conectarte correctamente desde cualquier dispositivo.",
        },
        {
          titulo: "Material de Apoyo",
          descripcion:
            "Documentos, guías, resúmenes y ejercicios por materia para apoyar tu aprendizaje.",
        },
      ],
    },
    {
      titulo: "Sobre la Carrera",
      items: [
        {
          titulo: "Plan de Estudios",
          descripcion:
            "Consulta las materias organizadas por año con una vista detallada de su contenido.",
        },
        {
          titulo: "Misión y Visión",
          descripcion:
            "Conoce la razón de ser de la carrera, su enfoque educativo y proyección institucional.",
        },
        {
          titulo: "Información Oficial",
          descripcion:
            "Todo lo que necesitas saber sobre tu formación, objetivos académicos y perfil profesional.",
        },
      ],
    },
    {
      titulo: "Centro de Estudiantes",
      items: [
        {
          titulo: "Logros de Gestión",
          descripcion:
            "Revisa el cumplimiento del plan de trabajo, actividades realizadas y avances en infraestructura y tecnología.",
        },
        {
          titulo: "Actividades Estudiantiles",
          descripcion:
            "Eventos, campañas, ferias, proyectos y participación activa del centro de estudiantes en beneficio de la comunidad.",
        },
      ],
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Encabezado */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Acerca de esta Aplicación
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Herramienta académica para estudiantes de Contaduría Pública
          y Administración Financiera
        </Typography>
      </Box>

      {/* Origen de la idea */}
      <Box textAlign="center" mb={6}>
        <Typography variant="body1" paragraph>
          Esta aplicación surge a partir de la iniciativa del
          ejecutivo del Centro de Estudiantes de departamento de
          Contaduría Pública y Administración Financiera,{" "}
          <strong>UNIV. KEVIN REYNAGA CONDORI</strong>, quien
          identificó la importancia de contar con una herramienta
          digital que facilite el cálculo de calificaciones y brinde
          acceso a información relevante para la vida académica.
        </Typography>
        <Typography variant="body1" paragraph>
          El desarrollo de esta solución estuvo a cargo del{" "}
          <strong>UNIV. KEVIN CALIZAYA</strong>, quien la diseñó con
          un enfoque moderno e intuitivo, priorizando la funcionalidad
          y adaptándola a las verdaderas necesidades de la comunidad
          estudiantil.
        </Typography>
      </Box>

      {/* Avatar del desarrollador */}
      <Box textAlign="center" mb={6}>
        <Avatar
          src={logoKevinCalizaya}
          alt="Kevin Calizaya"
          sx={{
            width: 150,
            height: 150,
            margin: "auto",
            border: "4px solid #fff",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        />
        <Typography variant="h6" mt={2}>
          UNIV. KEVIN CALIZAYA CHALLAPA
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Desarrollador Principal
        </Typography>
      </Box>
      <Typography
        variant="h4"
        component="h2"
        align="center"
        gutterBottom
        color="#f70000ff"
        fontWeight="600"
      >
        Bondades de la Aplicación
      </Typography>
      {/* Secciones agrupadas */}
      {secciones.map((grupo, i) => (
        <Box key={i} mb={6}>
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            gutterBottom
            color={
              i === 0
                ? "primary"
                : i === 1
                  ? "secondary"
                  : "success.main"
            }
          >
            {grupo.titulo}
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {grupo.items.map((item, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    p: 2,
                    boxShadow: 3,
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                    >
                      {item.titulo}
                    </Typography>
                    <Typography variant="body2">
                      {item.descripcion}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Container>
  );
};

export default AcercaDe;
